import {
  getMeetingConfig,
  getTabList,
  getMeetingConfigByUrl,
} from "@/api/meeting";

export default {
  namespaced: true,
  state: {
    isMobile: false,
    config: null,
    platformId: "", // 根据域名换取的id
    tabList: null,
    liveMeetingId: "", // 获取报名订单和会议时使用该值
    pcIndexPath: "", // 首页的路径
    // 1-外链;2-子菜单;5-会议;6-资讯;7-附件;8-课程 11-图文 12-图文+附件 13-投稿 14-日程
    RoutesPath: {
      11: "/richText",
      12: "/attachments",
      13: "/contribute",
      14: "/schedule",
    },
  },
  getters: {
    getIsMobile: (state) => state.isMobile,
    getConfig: (state) => state.config,
    getPlatformId: (state) => state.platformId,
    getTabList: (state) => state.tabList,
    getLiveMeetingId: (state) => state.liveMeetingId,
    getPcIndexPath: (state) => state.pcIndexPath,
  },
  mutations: {
    setIsMobile(state, payload) {
      state.isMobile = payload;
    },
    setConfig(state, payload) {
      state.config = payload;
    },
    setPlatformId(state, payload) {
      state.platformId = payload;
      localStorage.setItem("platformId", payload);
    },
    setLiveMeetingId(state, payload) {
      state.liveMeetingId = payload;
    },
    setTabList(state, payload) {
      state.tabList = payload;
    },
    setPcIndexPath(state, payload) {
      state.pcIndexPath = payload;
    },
  },
  actions: {
    async getMeetingConfigAction({ commit }, params) {
      try {
        let res;
        if (params.type === "id") {
          res = await getMeetingConfig(params.id);
        } else if (params.type === "url") {
          res = await getMeetingConfigByUrl(params.url);
        }
        const { results } = res;
        const { platformId, liveMeetingId } = results;
        commit("setConfig", results);
        commit("setPlatformId", platformId);
        commit("setLiveMeetingId", liveMeetingId);
        if (results.appid && results.platformId) {
          return Promise.resolve(results);
        } else {
          return false;
        }
      } catch (err) {
        return false;
      }
    },
    async getTabListAction({ state, commit }) {
      try {
        const res = await getTabList(state.platformId);
        const { results } = res;
        commit("setTabList", results);
        if (results.length) {
          const filterRoute = results.filter((item) => item.subjectType !== 1);
          commit(
            "setPcIndexPath",
            `${state.RoutesPath[filterRoute[0].subjectType]}?id=${
              filterRoute[0].subjectId
            }`
          );
          return Promise.resolve(results);
        } else {
          commit("setPcIndexPath", "/error");
          return false;
        }
      } catch (err) {
        return false;
      }
    },
  },
};
